module.exports = __webpack_public_path__ + "static/img/GP.ee7ce948.png";